import { render, staticRenderFns } from "./AttendersMenu.vue?vue&type=template&id=0686f3fc&scoped=true&"
import script from "./AttendersMenu.vue?vue&type=script&lang=js&"
export * from "./AttendersMenu.vue?vue&type=script&lang=js&"
import style0 from "./AttendersMenu.vue?vue&type=style&index=0&id=0686f3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686f3fc",
  null
  
)

export default component.exports